import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { busesAPI } from "components/Apis/Buses";

export const fetchBuses = createAsyncThunk(
    'filter/fetchBuses',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await busesAPI.filter(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const busSlice = createSlice({
    name: 'buses',
    initialState: {
        buses: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBuses.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBuses.fulfilled, (state, action) => {
                state.loading = false;
                state.buses = action.payload; // Store the list of people
            })
            .addCase(fetchBuses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
    },
});

export default busSlice.reducer;